module.exports = __webpack_public_path__ + "lk.svg?df0673653318852cda68aff2aae934a8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/lk.svg
// module id = 1056
// module chunks = 27